export default __webpack_public_path__ + "static/media/benefit_9@2x.77903814.png";